import React, { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";
import { classNames } from "../helpers/classNames";
import ProfileOnlineButton from "../components/elements/ProfileOnlineButton";
import { useDispatch, useSelector } from "react-redux";
import LogoutModal from "../components/elements/LogoutModal";
import { toast } from "react-toastify";
import { setAuthData } from "../store/slice/authSlice";
import { useSocket } from "../components/socket/SocketProvider";
import { appointmentClose } from "../service/videoCallService";
import { logoutRequest } from "../service/authService";
import { updateProfileService } from "../service/profileService";
import { setManualOffline } from "../util/consultantPresence";
import Cookies from "js-cookie";

const Sidebar = ({ data, handleDelete = () => { }, setprofileMenuToggle }) => {
  const [showModal, setShowModal] = useState(false);
  const [loaded, setLoaded] = useState(true);
  const closeModal = () => setShowModal(false);
  const dispatch = useDispatch();
  const socket = useSocket();
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const profile = useSelector((state) => state?.initialProfileSlice?.data);
  const appointmentData = JSON.parse(localStorage.getItem("appointmentData"));

  const handleLogOut = () => {
    const targetId = user?._id || profile?._id || JSON.parse(localStorage.getItem("userDetails") || "{}")?._id;
    const token = localStorage.getItem("auth_token") || Cookies.get("auth_token");

    // 1. Immediately notify socket of offline status
    if (socket && targetId) {
      try {
        socket.emit("userOffline", targetId);
        socket.emit("userOffline");
      } catch (_) {}
    } else if (socket) {
      try {
        socket.emit("userOffline");
      } catch (_) {}
    }

    // 2. Set manual offline flag
    setManualOffline(true);

    // 3. Update DB to offline before wiping token
    if (token) {
      try {
        updateProfileService({ onlineStatus: "offline" });
      } catch (_) {}
      if (typeof fetch !== "undefined") {
        try {
          const BASE_URL = process.env.REACT_APP_API_URL || "https://dev.api.prontopsy.com/api/v1";
          const formData = new FormData();
          formData.append("onlineStatus", "offline");
          fetch(`${BASE_URL}/user/edit`, {
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
            keepalive: true,
          }).catch(() => {});
        } catch (_) {}
      }
    }

    // 4. Send API logout request
    logoutRequest();

    // 5. Close appointment if any
    if (appointmentData?.appointmentId) {
      appointmentClose({
        appointmentId: appointmentData?.appointmentId,
      }).then((res) => {
        localStorage.removeItem("joined");
        try {
          socket?.emit("videoSessionDisconnect", {
            disconnect: true,
            appointmentId: appointmentData?.appointmentId,
          });
          socket?.emit("chatDisconnect", {
            disconnect: true,
            appointmentId: appointmentData?.appointmentId,
          });
          if (user?.roleCode === "consultant") {
            socket?.emit("consultantBusy", {
              consultantId: user?._id,
              userId: appointmentData?.callerData?.user?.id,
              isBusy: false,
            });
          }
        } catch (_) {}
      });
    }

    // 6. Clear auth storage
    dispatch(setAuthData({}));
    localStorage.removeItem("auth_token");
    Cookies.remove("auth_token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("appointmentData");
    localStorage.removeItem("joined");

    // 7. Disconnect socket cleanly
    try {
      socket?.disconnect();
    } catch (_) {}

    toast.success("You are logged out!");
    setLoaded(false);
    setTimeout(() => {
      setShowModal(false);
      setLoaded(true);
      window.location.href = "/signin";
    }, 500);
  };

  return (
    <>
      <div className="relative border border-slate-200 w-full h-screen space-y-5 pt-32 xl:pt-0 overflow-auto">
        {data.length > 0 && (
          <div className="relative w-full z-90">
            <div className="relative  divide-y divide-neutral-300 max-h-[500px] h-full">
              {data.map((item) => (
                <Fragment key={item._id}>
                  {item.separator ? (
                    <div className="border-t border-slate-200"></div>
                  ) : item.link ? (
                    <NavLink
                      to={item?.link}
                      onClick={() => setprofileMenuToggle(false)}
                      className={({ isActive }) =>
                        "group flex items-center py-5 px-4 gap-3 text-slate-900 font-medium transition-all duration-200 hover:text-white hover:bg-prontopsy-pink " +
                        (isActive ? "bg-prontopsy-pink text-white" : "text-slate-800 bg-white")
                      }>
                      {({ isActive }) => (
                        <>
                          <div
                            className={
                              "text-prontopsy-blue hover:text-white  w-5 h-5 flex items-center justify-center text-lg group-hover:text-white transition-all duration-200 " +
                              (isActive ? "text-white" : "text-prontopsy-500")
                            }>
                            <i className={"fa-regular fa-fw " + item.icon}></i>
                          </div>
                          <div
                            className={
                              "text-xs uppercase font-UnisonPro italic font-bold group-hover:text-white " +
                              (isActive ? "text-white" : "text-prontopsy-blue")
                            }>
                            {item.label}
                          </div>
                        </>
                      )}
                    </NavLink>
                  ) : (
                    <button
                      type="button"
                      className={classNames(
                        "group w-full flex items-center py-2 px-4 gap-3 text-prontopsy-blue font-medium transition-all duration-200 !border-b !rounded-none !pb-5 !pt-5"
                      )}
                      onClick={handleDelete}>
                      <div className=" w-5 h-5 flex items-center justify-center text-lg text-prontopsy-500 group-hover:text-prontopsy-100 transition-all duration-200">
                        <i className={"fa-regular fa-fw " + item.icon}></i>
                      </div>
                      <div className="text-prontopsy-blue text-xs uppercase font-UnisonPro italic font-bold">
                        {item.label}
                      </div>
                    </button>
                  )}
                </Fragment>
              ))}
            </div>
          </div>
        )}
        {user?.roleCode === "consultant" && (
          <div className="!mt-4 pb-4">
            <ProfileOnlineButton
              data={profile && profile?.onlineStatus}
              id={profile?._id || user?._id}
              size="default"
              showAutoPref={true}
            />
          </div>
        )}
      </div>

      <LogoutModal show={showModal} onClose={closeModal} onConfirm={handleLogOut} loaded={loaded} />
    </>
  );
};

export default Sidebar;
